import React, { useEffect, useMemo, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { Link } from 'react-router-dom';
import { FaEdit, FaSearch, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const ProgramServiceList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [dataList, setDataList] = useState([]);

  // Fetch on mount  ---------------------  (removed trailing space)
  useEffect(() => {
    callAPI('get', 'admin/program-resource');
  }, []);

  // Normalize and set list when response is ready
  useEffect(() => {
    if (statusCode === 200) {
      const list = Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data)
        ? response.data
        : [];
      setDataList(list);
    }
  }, [response, statusCode]);

  const deleteRecord = (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      // removed space before /${id}
      callAPI('delete', `admin/program-resource/${id}`, '');
    }
  };

  useEffect(() => {
    if (statusCode === 202) {
      toast.success('File deleted successfully!');
      callAPI('get', 'admin/program-resource');
    }
  }, [statusCode]);

  // <-- use program?.name instead of program_name
  const filteredList = useMemo(
    () =>
      dataList.filter((item) => {
        const pName = (item?.program?.name || '').toLowerCase();
        const type = (item?.type || '').toLowerCase();
        const q = searchTerm.toLowerCase();
        return pName.includes(q) || type.includes(q);
      }),
    [dataList, searchTerm]
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
          <div className="col-md-6">
              <PageHeading title="Program Service List" subTitle="Manage Program Resources" />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.programservice.add}>
                <button className="btn btn-primary">Add New</button>
              </Link>
            </div>
          </div>

          <div className="card shadow-sm rounded-lg mt-4">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-3">
                  <h5 className="mb-0 fw-semibold">Uploaded Files</h5>
                </div>
                <div className="col-md-9 d-flex justify-content-end">
                  <div className="input-group w-100 w-md-auto">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by type or program name"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th>#</th>
                    <th>Program</th>
                    <th>Type</th>
                    <th>File</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredList.length > 0 ? (
                    filteredList.map((item, idx) => (
                      <tr key={item.id}>
                        <td>{idx + 1}</td>
                        {/* ✅ show program name properly */}
                        <td>{item.program?.name || `#${item.program_id}`}</td>
                        <td>{item.program?.type}</td>
                        <td>
                          {item.file ? (
                            <a href={item.file} target="_blank" rel="noreferrer">
                              View File
                            </a>
                          ) : (
                            'N/A'
                          )}
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2 align-items-center">
                            {item.file && (
                              <a href={item.file} target="_blank" rel="noreferrer">
                                <button className="sys-list-table__action view" title="View File">
                                  View
                                </button>
                              </a>
                            )}
                            <Link to={uiRoutes.admin.programservice.edit.replace(':id', item.id)}>
                              <button className="sys-list-table__action edit" title="Edit">
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete"
                              onClick={() => deleteRecord(item.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ProgramServiceList;
